import './assets/styles/circle-checkbox.scss';
import TickWhiteIcon from 'app/shared/assets/svgs/tick-white.svg';

export const CircleCheckBox = () => {
  return (
    <div className="circle-checkbox">
      <img src={TickWhiteIcon} alt="" />
    </div>
  )
}